import React from "react";
import { useTranslation } from "react-i18next";
import { Hourglass } from "lucide-react";
import { useWidgetRequests } from "../context/WidgetRequestContext";

/**
 * Warning notice shown while any widget request has run past `SLOW_REQUEST_MS`.
 * The live region stays mounted so screen readers announce the message when it
 * appears, politely rather than interrupting.
 */
const SlowRequestNotice: React.FC = () => {
  const { t } = useTranslation();
  const requests = useWidgetRequests();

  // Outside the widget there is no request tracker — render nothing at all so
  // non-widget hosts of shared components (e.g. place-your-order) are unaffected.
  if (!requests) return null;
  const isSlow = requests.isSlow;

  return (
    <output aria-live="polite" data-testid="slow-request-notice" className="gcw:block">
      {isSlow && (
        <span className="slow-request-notice gcw:flex gcw:items-start gcw:gap-2 gcw:rounded-md gcw:border gcw:border-warning gcw:bg-amber-50 gcw:p-bs-3 gcw:mb-bs-3 gcw:text-amber-800 widget-warning-panel">
          <Hourglass size={18} aria-hidden="true" className="gcw:shrink-0 gcw:mt-0.5" />
          <span>{t("request_slow_message", "This is taking longer than expected. Please bear with us…")}</span>
        </span>
      )}
    </output>
  );
};

export default SlowRequestNotice;
